// extracted by mini-css-extract-plugin
export default {"StartPage":"StartPage_StartPage__oK+Yl"};